<div class="revenue-chart">
    <h4 class="widget__heading">Actual All Branch Progress Towards Great</h4>
    <div class="revenue-chart__bar">
        <div
            class="revenue-chart__bar-progress revenue-chart__bar-progress--{{
                location.location.toLowerCase()
            }}"
            [attr.title]="getBranchGreatTargetProgress(location.locationId).toFixed(1) + '%'"
            *ngFor="let location of performanceWidths"
            [ngStyle]="{ left: getBranchGreatTargetProgress(location.locationId).toFixed(1) + '%' }"
        ></div>
    </div>
    <div class="revenue-keys">
        <div
            class="revenue-key"
            *ngFor="let locationPerformance of performanceWidths"
        >
            <span
                class="revenue-key__colour revenue-key__colour--{{
                    locationPerformance.location.toLowerCase()
                }}"
            ></span>
            <span class="revenue-key__location">{{
                locationPerformance.location
            }}</span>
            <span class="revenue-key__percentage">{{
                getBranchGreatTargetProgress(locationPerformance.locationId).toFixed(1) + '%'
            }}</span>
        </div>
    </div>
</div>
